import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { TooltipComponent } from "@shared/components/commons/tooltip/tooltip.component";
import { ButtonComponent } from "@shared/controls/button/button.component";
import { DatePickerComponent } from "@shared/controls/date-picker/date-picker.component";
import { DateFormatPipe, DateFormatType } from "@shared/pipes/dateFormatPipe";
import { DatepickerHelper } from "@shared/validators/date-picker-form-validators";
import { SigningStatus } from "@models/annual-statements/annual-statement-enums";
import { ReminderStatus } from "@models/reminders/reminder.enum";
import { ReminderRecord } from "@models/reminders/reminder-record";

@Component({
  selector: 'app-reminder',
  standalone: true,
  imports: [
    ButtonComponent,
    TooltipComponent,
    NgbTooltip,
    DateFormatPipe,
    DatePickerComponent,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './reminder.component.html',
  styleUrl: './reminder.component.scss'
})
export class ReminderComponent {
  @Input() title = 'Signing Reminders';
  @Input() sendTooltipText = 'Send Ad-Hoc Signing Reminder';
  @Input() reminderList: ReminderRecord[] = [];
  @Input() signingStatus: SigningStatus | undefined;
  @Output() addReminder = new EventEmitter<Date>();
  @Output() removeReminder = new EventEmitter<string>();
  @Output() showReminder = new EventEmitter<boolean>();

  protected readonly ReminderStatus = ReminderStatus;
  protected readonly SigningStatus = SigningStatus;

  minDate = DatepickerHelper.getStructFromDateDayAfter(new Date());
  maxDate = DatepickerHelper.getNextYearStruct();
  DateFormatType = DateFormatType;

  form = new FormGroup({
    reminderDate: new FormControl<Date>(DatepickerHelper.getDateWithDaysAfterToday(1)),
  });


  showReminderPopup(): void {
    this.showReminder.emit(true);
  }

  onRemoveReminder(id: string): void {
    this.removeReminder.emit(id);
  }

  onAddReminder(): void {
    const date = this.form.controls.reminderDate.value;

    if(date) {
      this.addReminder.emit(date);
    }
  }

  disableSendBtn(): boolean {
    return this.signingStatus !== SigningStatus.Sent && this.signingStatus !== SigningStatus.SentViaEmail;
  }
}
